import { Routes } from '@angular/router';
import {NotFoundComponent} from "./components/pages/not-found/not-found.component";
import {AdminGuard} from "./guard/admin.guard";

import { SignInComponent } from './components/pages/sign-in/sign-in.component';

import { AdminsComponent } from './components/pages/admins/admins.component';
import { MenuManagerComponent } from './components/pages/menu-manager/menu-manager.component';
import { PagesComponent } from './components/pages/pages/pages.component';
import { PostsComponent } from './components/pages/posts/posts.component';
import { SettingComponent } from './components/pages/setting/setting.component';
import { FileManagerComponent } from './components/layout/file-manager/file-manager.component';
import { SliderComponent } from './components/pages/slider/slider.component';

export const routes: Routes = [
  {path: '', component: MenuManagerComponent, canActivate: [AdminGuard], data: { permission: '' }},
  {path: 'menu', component: MenuManagerComponent, canActivate: [AdminGuard], data: { permission: 'menu' }},
  { path: 'pages', component: PagesComponent, canActivate: [AdminGuard], data: { permission: 'pages' } },
  { path: 'posts', component: PostsComponent, canActivate: [AdminGuard], data: { permission: 'posts' } },
  { path: 'slider', component: SliderComponent, canActivate: [AdminGuard], data: { permission: 'slider' } },
  { path: 'admins', component: AdminsComponent, canActivate: [AdminGuard], data: { permission: 'admins' } },
  { path: 'setting', component: SettingComponent, canActivate: [AdminGuard], data: { permission: 'settings' } },

  {path: 'files', component: FileManagerComponent, canActivate: [AdminGuard]},


  
  {path: 'login', component: SignInComponent},
  { path: 'not-found', component: NotFoundComponent },
  { path: '**', redirectTo: '/not-found' }

];